import { BaseClientType, EditClientStepProps } from '../../types';
import { Box, Button } from '@mui/material';
import { Controller } from 'react-hook-form';
import { JSX, useState } from 'react';
import PartyList from '../../../parties/partyList';
import SelectPartiesDialog from '../../../fna/editFnaPage/steps/selectPartiesDialog';

/**
 * Step with related parties for client
 */
const ClientRelatedPartiesStep = ({
  client,
  control,
  commitChanges,
}: EditClientStepProps<BaseClientType>): JSX.Element => {
  const [selectDialogOpen, setSelectDialogOpen] = useState(false);

  return (
    <Controller
      name="parties"
      control={control}
      render={({ field: { onChange, value } }): JSX.Element => (
        <Box>
          <Box className="flex justify-end">
            <Button variant="outlined" onClick={(): void => setSelectDialogOpen(true)}>
              Choose parties
            </Button>
          </Box>
          <PartyList
            parties={client.parties}
            onDelete={(partyForDelete): void => {
              onChange(client.parties.filter(({ id }) => id !== partyForDelete.id));
              commitChanges();
            }}
            onChange={(updatedParty): void => {
              const updatedParties = [...client.parties];
              const partyIndex = updatedParties.findIndex(({ id }) => id === updatedParty.id);
              if (partyIndex !== -1) {
                updatedParties[partyIndex] = updatedParty;
                onChange(updatedParties);
                commitChanges();
              }
            }}
          />
          <SelectPartiesDialog
            open={selectDialogOpen}
            onClose={(selectedParties): void => {
              // if some parties was selected, update client parties field
              if (selectedParties) {
                onChange([
                  ...value,
                  ...selectedParties.map((selectedParty) => ({
                    ...selectedParty,
                    roleplayerID: client.roleplayerID,
                    // Client parties are always primary
                    isPrimary: true,
                  })),
                ]);
              }
              commitChanges();
              setSelectDialogOpen(false);
            }}
          />
        </Box>
      )}
    />
  );
};

export default ClientRelatedPartiesStep;
